/**
 * functions
 */
import { updateLazy } from '../functions/lazy';
import { initTippy } from '../functions/tippy';

/**
 * common & components
 */
import '../common/eshop';
import '../common/window';
import '../common/info-messages';
import '../common/toggle-password';
import '../common/cookiebot-refresh';

import '../../../vendor/rshop/frontend/resources/js/ui/ui_spinner'
import '../common/product-cart-quantity';
import '../common/spinner-quick-update';

import '../components/modal/modal-back';
import '../components/modal/modal-jump';
import '../components/modal/modal-remote';
import '../components/modal/modal-watchdog';

import '../components/header';
import '../components/footer';

/**
 * script
 */
window.Cart.customCallbacks.addedItem = function (form, response) {
    window.rEvent.dispatch('Custom.Cart.addedItem', { form, response })
}
window.Cart.customCallbacks.updatedItem = function (input, response) {
    window.rEvent.dispatch('Custom.Cart.updatedItem', { input, response })
}
window.Cart.customCallbacks.removedItem = function (form, response) {
    window.rEvent.dispatch('Custom.Cart.removedItem', { form, response })
}

Compare.customCallbacks.addedItem = function (form, response) {
    if (!response.status) {
        return;
    }

    $('.js-compare-badge')
        .html(response.count)
        .toggleClass('is-active', response.count > 0);
}

window.updateLazy = updateLazy();

document.addEventListener('DOMContentLoaded', () => {
    updateLazy();
    initTippy()
});

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-back').forEach(back => {
        back.addEventListener('click', event => {
            if (event.currentTarget.getAttribute('href') == '#') {
                window.history.back()
            }
        })
    })
})